import { OnInit, OnDestroy, ElementRef, Renderer2, QueryList } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Action } from '../objects/DetailObject';
import { HeaderService } from '../services/header.service';
import { TokenManager } from '../Globals';
import { NgProgress } from '@ngx-progressbar/core';
import { Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';
import { MainLoadingService } from '../services/main-loading.service';
import { MatMenuTrigger } from '@angular/material';
import { WorkflowReturnService } from '../services/workflow-return.service';
var PrimaryMenuComponent = /** @class */ (function () {
    function PrimaryMenuComponent(loginService, headerService, router, tokenManager, globals, workspaceService, mainLoadingService, progress, render, elRef, workflowReturnService) {
        var _this = this;
        this.loginService = loginService;
        this.headerService = headerService;
        this.router = router;
        this.tokenManager = tokenManager;
        this.globals = globals;
        this.workspaceService = workspaceService;
        this.mainLoadingService = mainLoadingService;
        this.progress = progress;
        this.render = render;
        this.elRef = elRef;
        this.workflowReturnService = workflowReturnService;
        this.groupList = [];
        this.hiddenList = [];
        this.hiddenActionList = [];
        this.menuActions = [];
        this.navbarOpen = false;
        this.showBtnMore = false;
        this.actionsReady = false;
        this.collapsed = false;
        this.fixHeight = 0;
        this.sub = headerService.selectedMenuChanged$.subscribe(function (result) {
            if (result == 'clearSelected') {
                _this.currentMenu = '';
                _this.tokenManager.delete("BRNCurrentMenu");
            }
        });
    }
    PrimaryMenuComponent.prototype.clickout = function (event) {
        if (this.elRef.nativeElement.contains(event.target)) {
            // target is in this component
        }
        else {
            this.closeAll();
        }
    };
    PrimaryMenuComponent.prototype.onResize = function (event) {
        if (event.target.innerWidth < 992) {
            this.navbarOpen = false;
            this.hiddenActionList = [];
            //  this.hiddenList = [];
            this.onCollapsedMenu();
            this.showBtnMore = false;
            this.collapsed = true;
        }
        else {
            this.collapsed = false;
            if (this.actionsReady)
                this.updateActionsDisplay();
        }
    };
    PrimaryMenuComponent.prototype.toggleNavbar = function () {
        this.navbarOpen = !this.navbarOpen;
    };
    PrimaryMenuComponent.prototype.returnId = function (item) {
        if (item.ActionName) {
            return item.ActionName.replace(/\s/g, '') + "_link";
        }
        else {
            return "nice_link";
        }
    };
    PrimaryMenuComponent.prototype.loadHeaderMenu = function () {
        var _this = this;
        if (this.globals.Session) {
            this.headerService.createHeaderCard().subscribe(function (id) {
                _this.cardId = id;
                _this.headerService.getHeaderMenuItems(id).subscribe(function (groups) {
                    _this.groupList = JSON.parse(groups);
                    if (_this.groupList) {
                        _this.sortGroupMenuActions(_this.groupList);
                        _this.menuActions = [];
                        var menuAction = [];
                        var baseGroup = _this.groupList.filter(function (x) { return x.GroupId == "00000000-0000-0000-0000-000000000000"; });
                        var group = _this.groupList.filter(function (x) { return x.GroupId != "00000000-0000-0000-0000-000000000000"; });
                        baseGroup.forEach(function (group) {
                            group.Actions.forEach(function (action) {
                                menuAction.push(action);
                            });
                        });
                        group.forEach(function (group) {
                            var action = new Action();
                            action.ActionName = group.GroupDisplay;
                            if (group.Actions) {
                                action.SubActions = [];
                                var subActions = _this.sortMenuActions(group.Actions);
                                subActions.forEach(function (result) {
                                    action.SubActions.push(result);
                                });
                            }
                            menuAction.push(action);
                        });
                        _this.menuActions = _this.sortMenuActions(menuAction);
                        // if (this.menuActions.length > 10) {
                        //   this.extraMenuActions  = this.menuActions.slice(10);
                        //   this.menuActions = this.menuActions.slice(0, 10);
                        // }
                        if (_this.tokenManager.retrieve("BRNCurrentMenu")) {
                            _this.currentMenu = _this.tokenManager.retrieve("BRNCurrentMenu").replace(/"/g, "");
                        }
                    }
                });
            });
        }
    };
    PrimaryMenuComponent.prototype.sortMenuActions = function (menuAction) {
        return menuAction.sort(function (a, b) {
            if (a.ActionOrder > b.ActionOrder) {
                return 1;
            }
            else if (a.ActionOrder < b.ActionOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    PrimaryMenuComponent.prototype.sortGroupMenuActions = function (groupAction) {
        this.groupList = groupAction.sort(function (a, b) {
            if (a.GroupOrder > b.GroupOrder) {
                return 1;
            }
            else if (a.GroupOrder < b.GroupOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    PrimaryMenuComponent.prototype.selectMenuHeader = function (selectedCommand) {
        var _this = this;
        this.currentMenu = selectedCommand;
        this.tokenManager.store("BRNCurrentMenu", this.currentMenu);
        this.mainLoadingService.setProgressBar(true);
        if (!this.cardId) {
            this.headerService.createHeaderCard().subscribe(function (id) {
                _this.cardId = id;
            });
        }
        this.headerService.selectHeaderMenuItems(this.cardId, selectedCommand).subscribe(function (result) {
            var resultObject = JSON.parse(result);
            if (resultObject.ReturnType == "0") {
                if (resultObject.Arguments) {
                    var path = [];
                    resultObject.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    _this.router.navigated = false;
                    _this.mainLoadingService.setProgressBar(false);
                    // this.progressRef.complete();
                    _this.router.navigate(path);
                    _this.navbarOpen = !_this.navbarOpen;
                }
            }
            else {
                _this.workflowReturnService.handleWorkflowReturn(resultObject);
                _this.mainLoadingService.setProgressBar(false);
                _this.navbarOpen = !_this.navbarOpen;
                _this.currentMenu = null;
            }
        }, function (error) {
            _this.mainLoadingService.setProgressBar(false);
            //this.progressRef.complete();
        });
    };
    PrimaryMenuComponent.prototype.hasActiveSubAction = function (menuItem) {
        var _this = this;
        return menuItem.SubActions.findIndex(function (x) { return x.ActionCommand == _this.currentMenu; }) > -1;
    };
    PrimaryMenuComponent.prototype.ngOnInit = function () {
        this.collapsed = window.innerWidth < 992;
        this.progressRef = this.progress.ref();
        this.currentSessionId = this.globals.Session.SessionKey;
        this.loadHeaderMenu();
    };
    PrimaryMenuComponent.prototype.ngOnDestroy = function () {
        if (this.sub)
            this.sub.unsubscribe();
    };
    PrimaryMenuComponent.prototype.afterInit = function () {
        this.actionsReady = true;
        this.updateActionsDisplay();
    };
    PrimaryMenuComponent.prototype.updateActionsDisplay = function () {
        var availableSpace;
        availableSpace = this.primaryMenu.nativeElement.offsetWidth;
        if (this.menuContainer) {
            var actionsWidth = this.menuContainer.nativeElement.offsetWidth;
            actionsWidth = actionsWidth + 44;
            if (actionsWidth > availableSpace) {
                var id_1 = this.menuContainer.nativeElement.children[this.menuContainer.nativeElement.children.length - 1].getAttribute("id");
                if (this.hiddenList.length > 0) {
                    this.render.insertBefore(this.hiddenMenu.nativeElement, this.menuContainer.nativeElement.children[this.menuContainer.nativeElement.children.length - 1], this.hiddenMenu.nativeElement.children[0]);
                    this.hiddenActionList.unshift(this.menuActions.find(function (x) { return x.ActionName == id_1; }));
                }
                else {
                    this.render.appendChild(this.hiddenMenu.nativeElement, this.menuContainer.nativeElement.children[this.menuContainer.nativeElement.children.length - 1]);
                    var index = this.hiddenActionList.findIndex(function (x) { return x.ActionName == id_1; });
                    if (index > -1) {
                        this.hiddenActionList.splice(index, 1);
                    }
                    else {
                        this.hiddenActionList.unshift(this.menuActions.find(function (x) { return x.ActionName == id_1; }));
                    }
                }
                // record width
                this.hiddenList.push(actionsWidth);
                // show the btn
                this.showBtnMore = true;
            }
            else {
                this.moveItemToVisible(availableSpace);
                // Hide the dropdown btn if hidden list is empty
                if (this.hiddenList.length < 1) {
                    this.showBtnMore = false;
                }
            }
            // Recur if the visible list is still overflowing the nav
            if (actionsWidth > availableSpace) {
                this.updateActionsDisplay();
            }
        }
    };
    PrimaryMenuComponent.prototype.moveItemToVisible = function (availableSpace) {
        if (availableSpace > this.hiddenList[this.hiddenList.length - 1]) {
            // Move the item to the visible list
            this.render.appendChild(this.menuContainer.nativeElement, this.hiddenMenu.nativeElement.children[0]);
            this.hiddenList.pop();
            this.hiddenActionList.shift();
            //recur if still have item that can move to visible list
            this.moveItemToVisible(availableSpace);
        }
    };
    PrimaryMenuComponent.prototype.onCollapsedMenu = function () {
        // this.updateActionsDisplay();
        for (var i = 0; i < this.hiddenMenu.nativeElement.children.length; i++) {
            this.render.appendChild(this.menuContainer.nativeElement, this.hiddenMenu.nativeElement.children[i]);
        }
    };
    PrimaryMenuComponent.prototype.menuOpened = function (actionName) {
        var _this = this;
        this.matMenuTriggerList.forEach(function (matMenu) {
            if (matMenu.menuOpen) {
                if (_this.hiddenActionList.findIndex(function (x) { return x.ActionName == actionName; }) < 0 && matMenu.menuData != actionName) {
                    // close the others
                    matMenu.closeMenu();
                }
            }
        });
    };
    PrimaryMenuComponent.prototype.closeAll = function () {
        this.matMenuTriggerList.forEach(function (matMenu) {
            if (matMenu.menuOpen) {
                matMenu.closeMenu();
            }
        });
    };
    return PrimaryMenuComponent;
}());
export { PrimaryMenuComponent };
